// Flip this to false to take the full standings (champions + full table) off
// the landing page, leaving just a message that results aren't available
// yet. Flip back to true to bring it all back — no other code changes needed.
export const SHOW_GRAND_RESULTS = true;
